import Phaser from 'phaser';

export interface EnemyConfig {
  texture: string;
  points: number;
  health: number;
  fireRate: number; // ms between shots
  projectileSpeed: number;
  projectileTexture: string;
}

export class Enemy extends Phaser.Physics.Arcade.Sprite {
  public points: number;
  public health: number;
  public maxHealth: number;
  public fireRate: number;
  public projectileSpeed: number;
  public projectileTexture: string;
  public lastFired: number = 0;
  public gridX: number = 0;
  public gridY: number = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    config: EnemyConfig
  ) {
    super(scene, x, y, config.texture);

    this.points = config.points;
    this.health = config.health;
    this.maxHealth = config.health;
    this.fireRate = config.fireRate;
    this.projectileSpeed = config.projectileSpeed;
    this.projectileTexture = config.projectileTexture;

    // Add to scene and enable physics
    scene.add.existing(this);
    scene.physics.add.existing(this);
  }

  takeDamage(amount: number = 1): boolean {
    this.health -= amount;
    
    // Flash white when hit
    this.setTint(0xffffff);
    this.scene.time.delayedCall(50, () => {
      this.clearTint();
    });

    return this.health <= 0;
  }

  canFire(time: number): boolean {
    return time > this.lastFired + this.fireRate;
  }

  setLastFired(time: number): void {
    this.lastFired = time;
  }

  setGridPosition(gridX: number, gridY: number): void {
    this.gridX = gridX;
    this.gridY = gridY;
  }
}






